import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'ramda';
import { arrayOperators, columnTypeOperators } from '../api';
import { ColumnType, Operator } from '../api/generated';
/**
 * Checks if a filter is empty (e.g. "All" filter)
 */
export function isEmptyFilter(filter) {
    const andConditions = filter?.andConditions;
    if (!andConditions || isEmpty(andConditions)) {
        return true;
    }
    return andConditions.every((ac) => isEmpty(ac?.orConditions));
}
const getOperators = (column) => {
    const dataType = column?.dataType;
    const isArray = column?.isArray;
    if (isArray)
        return arrayOperators;
    return columnTypeOperators[dataType ?? 'STRING'];
};
export const getOperatorItems = (column, disabledOperators) => {
    const operators = getOperators(column);
    return operators.map((operator) => ({
        value: operator,
        disabled: disabledOperators?.includes(operator) ?? false,
        label: () => _jsx(FormattedMessage, { id: `filter.operator.${operator.toLowerCase()}`, defaultMessage: operator }),
    }));
};
export const getColumnsItems = (columns) => columns?.map(({ dataType, fieldName }) => ({
    value: fieldName,
    type: dataType,
})) ?? [];
export const getDataType = (columns, fieldName) => columns.find((i) => i.fieldName === fieldName)?.dataType;
export const getDefaultOperator = (columns, fieldName) => {
    const column = columns.find((i) => i.fieldName === fieldName);
    if (!column)
        return Operator.Equals;
    if (column.isArray)
        return Operator.Contains;
    if (column.dataType === ColumnType.String)
        return Operator.Contains;
    return Operator.Equals;
};
export const getAnyFieldHasDuplicityOperator = (fields) => fields.map((field) => field.operator).some((operator) => operator === Operator.Duplicity);
export const getAnyFieldIsEmpty = (fields) => fields.some((field) => !field.field || !field.operator);
const getIsEmptyCondition = (condition) => !condition.field && !condition.operator && !condition.value;
export const getIsEmptyFilter = (andConditions) => {
    return andConditions.every((andCondition) => andCondition.orConditions.every(getIsEmptyCondition));
};
/**
 * Converts form AndConditionsSchema to RowFilterCondition for API, filtering out empty conditions.
 * Only includes conditions with field and operator set.
 */
export function toFilterCondition(formData, baseCondition) {
    const validAndConditions = formData.andConditions
        .map((group) => ({
        ...group,
        orConditions: (group.orConditions ?? []).filter((c) => c?.field && c?.operator != null),
    }))
        .filter((group) => group.orConditions.length > 0);
    if (validAndConditions.length === 0) {
        return null;
    }
    const fixedConditions = baseCondition?.andConditions?.filter((c) => c.fixed) ?? [];
    return {
        andConditions: [...fixedConditions, ...validAndConditions],
        maxRecords: baseCondition?.maxRecords,
    };
}
//# sourceMappingURL=helpers.js.map